"use client";

import React from "react";
import { WooCommerceCartBlock } from "@/integrations/wordpress/WooCommerceCartBlock";
export default function CartContent() {
  return <section data-section-id="222459" id="cart-content" className="bg-background text-foreground py-20 md:py-32 relative overflow-hidden min-h-[80vh] flex items-center">
      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-4xl h-full max-h-[800px] bg-primary/5 blur-[120px] rounded-lg pointer-events-none" />

      <div className="container mx-auto px-4 md:px-6 relative z-10 max-w-5xl">
        <div className="mb-12 text-center md:text-left flex flex-col md:flex-row md:items-end justify-between gap-6 border-b border-border/30 pb-8">
          <div>
            <h1 className="text-4xl md:text-5xl font-bold font-serif tracking-tight mb-2">
              Your Selection
            </h1>
            <p className="text-muted-foreground font-default text-sm uppercase tracking-widest">
              Curated Blooms & Garden Treasures
            </p>
          </div>
          <div className="font-default text-xs text-accent-foreground bg-accent/50 px-3 py-1.5 rounded-md border border-border/40 inline-flex items-center gap-2">
            <span className="w-2 h-2 rounded-lg bg-primary animate-pulse"></span>
            BOUTIQUE CHECKOUT
          </div>
        </div>

        <div className="bg-card/60 backdrop-blur-sm border border-border/40 rounded-md p-4 md:p-8 lg:p-12 shadow-xl relative overflow-hidden">
          {}
          <div className="absolute inset-0 pointer-events-none rounded-md" />
          
          {}
          <div className="relative z-10 [&_.wc-block-cart-item__name]:font-bold [&_.wc-block-cart-item__name]:font-serif [&_.wc-block-cart-item__name]:text-xl [&_.wc-block-cart-item__price]:font-default [&_.wc-block-components-totals-item__value]:font-default [&_.wc-block-components-totals-item__value]:tracking-tight [&_.wc-block-cart__submit-button]:bg-accent [&_.wc-block-cart__submit-button]:text-accent-foreground [&_.wc-block-cart__submit-button]:rounded-md [&_.wc-block-cart__submit-button]:font-default [&_.wc-block-cart__submit-button]:uppercase [&_.wc-block-cart__submit-button]:tracking-widest">
            <WooCommerceCartBlock />
          </div>
        </div>
      </div>
    </section>;
}